import { Route } from '@angular/router';

export const EVE_ROUTES: Route[] = [
    {
        path: '',
        loadComponent: () => import('./eve.component').then((comp) => comp.EveComponent)
    }
];
